import { render } from "./index.vue?vue&type=template&id=284451ab&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=284451ab&lang=scss&scoped=true"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-284451ab"],['__file',"src/views/DashboardGestor/components/DashboardTotalizadoresCards/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "284451ab"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('284451ab', __exports__)) {
    console.log('reload')
    api.reload('284451ab', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=284451ab&scoped=true", () => {
    console.log('re-render')
    api.rerender('284451ab', render)
  })

}


export default __exports__